import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CandidateAuthService } from '@rekruto/core';

/**
 * Guards the signed-in candidate surfaces (mirror of core's company authGuard): a signed-out
 * visitor hitting a deep link lands on /login with `?returnUrl=` so the auth screen can bring
 * them back to where they were heading. AUTH_LOGIN_ROUTE's default is ['/login'] here.
 */
export const candidateAuthGuard: CanActivateFn = (_route, state) => {
  const auth = inject(CandidateAuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

/**
 * Keeps a signed-in candidate off the auth screens: /login and /register redirect to the
 * account's entry point instead of showing a form that would dead-end.
 */
export const signedOutGuard: CanActivateFn = () => {
  const auth = inject(CandidateAuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return true;
  return router.createUrlTree(['/']);
};
